// Google Analytics helper functions
export const initializeGA = (measurementId) => {
  // Load Google Analytics script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  // Initialize gtag function
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };

  // Configure gtag
  window.gtag('js', new Date());
  
  // Initially deny consent until user makes a choice
  window.gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });

  // Configure with measurement ID
  window.gtag('config', measurementId);
};

export const updateConsent = (cookieSettings) => {
  if (!window.gtag) return;

  window.gtag('consent', 'update', {
    analytics_storage: cookieSettings.analytics ? 'granted' : 'denied',
    ad_storage: cookieSettings.marketing ? 'granted' : 'denied',
    ad_user_data: cookieSettings.marketing ? 'granted' : 'denied',
    ad_personalization: cookieSettings.marketing ? 'granted' : 'denied',
  });
};

export const trackEvent = (eventName, parameters = {}) => {
  if (!window.gtag) return;
  
  window.gtag('event', eventName, {
    event_category: parameters.category || 'general',
    event_label: parameters.label,
    value: parameters.value,
    ...parameters
  });
};

export const trackPageView = (pagePath, pageTitle) => {
  if (!window.gtag) return;
  
  window.gtag('event', 'page_view', {
    page_title: pageTitle || document.title,
    page_location: window.location.origin + pagePath,
    page_path: pagePath
  });
};